import { Card, Button, Typography, CardContent, Grid } from '@mui/material';
import React, { useState } from 'react';
import { forgotPassword } from '../../modules/users';
import { useNotification } from '../../hooks/NotificationContext';

const ChangePassword = ({ user }) => {
  const [showResponse, setShowResponse] = useState(false);
  const { addNotification } = useNotification();

  const handleSubmit = async () => {
    try {
      await forgotPassword({ email: user.email });
      setShowResponse(true);
    } catch (err) {
      addNotification('danger', err.message);
    }
  };

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          {showResponse ? (
            <>
              <Grid item xs={12}>
                <Typography variant="h6" color="success.main">
                  Password Change Link Sent!
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" color="textSecondary">
                  Please check your email for instructions on how to change your
                  password.
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  Note: If you don’t see the email, please check your spam or
                  junk folder.
                </Typography>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={8}>
                <Typography variant="h5" sx={{ mb: 2 }}>
                  Change Your Password
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Click the button to receive a link at your registered
                  email.
                </Typography>
              </Grid>
              <Grid
                item
                xs={4}
                container
                justifyContent="flex-end"
                alignItems="center">
                <Button variant="outlined" onClick={handleSubmit}>
                  Send Reset Link
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ChangePassword;
